module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\n    Her kan du angive om du ønsker at skjule en eller flere igangværende opgaver.\n    "), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Bemærk, at ændringen udelukkende træder i kraft på igangværende opgaver, ikke på afsluttede, bogførte mv.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Igangværende opgaver (" + _vm._s(_vm.rows.length > 0 ? _vm.rows.length : '') + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "searchOptions": _vm.searchOptions,
      "paginationOptions": _vm.paginationOptions,
      "sortOptions": _vm.sortOptions,
      "styleClass": "vgt-table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'show') ? _c('div', [(props.row.show) ? _c('div', {
          staticClass: "coverage-indicator"
        }, [_c('div', {
          staticClass: "coverage-indicator good"
        }), _vm._v("\n                            Synlig\n                        ")]) : _c('div', {
          staticClass: "coverage-indicator"
        }, [_c('div', {
          staticClass: "coverage-indicator bad"
        }), _vm._v("\n                            Ikke synlig\n                        ")])]) : (props.column.field == 'action') ? _c('div', [(props.row.show) ? _c('div', [_c('button', {
          on: {
            "click": function($event) {
              return _vm.updateProject(props.row, false)
            }
          }
        }, [_vm._v("\n                                Skjul\n                            ")])]) : _c('div', [_c('button', {
          on: {
            "click": function($event) {
              return _vm.updateProject(props.row, true)
            }
          }
        }, [_vm._v("\n                                Gør synlig\n                            ")])])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 880643397)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad10ac3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/excludeProjects.vue
// module id = 922
// module chunks = 0